import { Outlet } from 'react-router-dom';
import SpaceNavigation from './SpaceNavigation';

/**
 * /space 及子路由的统一布局：应用 personal-theme 配色 + 浮动玻璃导航。
 */
export default function SpaceLayout() {
  return (
    <div className="min-h-screen personal-theme bg-background text-foreground">
      <SpaceNavigation />
      {/* 给底部浮动导航留出空间 */}
      <div className="pb-28">
        <Outlet />
      </div>
    </div>
  );
}
